import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { map } from 'rxjs/operators';

export interface CustomerClass {
  id: string;
  wineryId: string;
  classId?: number;
  className: string;
  classType: string;
  discountRate: number;
  caseDiscountRate: number;
  isPaid?: boolean;
  price?: number;
  priceType?: 'MONTHLY' | 'YEARLY' | 'UNA_TANTUM';
  validityDate?: Date | string;
  isActive?: boolean;
  isExpired?: boolean;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  // Backward compatibility: amountCents can be computed from price (price * 100)
  amountCents?: number;
}

export type CreateCustomerClass = Omit<CustomerClass, 'id' | 'isExpired' | 'createdAt' | 'updatedAt'>;

@Injectable({
  providedIn: 'root'
})
export class CustomerClassService {

  getAll(wineryId: string): Observable<CustomerClass[]> {
    return resource('crm://v2/customerclass')
      .params({ wineryId })
      .get<CustomerClass[]>()
      .pipe(
        map(classes => classes || [])
      );
  }

  getById(id: string): Observable<CustomerClass> {
    return resource('crm://v2/customerclass/{id}')
      .params({ id })
      .get<CustomerClass>();
  }

  create(customerClass: CreateCustomerClass): Observable<CustomerClass> {
    return resource('crm://v2/customerclass')
      .post<CustomerClass>(customerClass);
  }

  update(id: string, customerClass: CustomerClass): Observable<CustomerClass> {
    return resource('crm://v2/customerclass/{id}')
      .params({ id })
      .put<CustomerClass>(customerClass);
  }

  delete(id: string): Observable<void> {
    return resource('crm://v2/customerclass/{id}')
      .params({ id })
      .delete() as Observable<void>;
  }
}

